import { render, staticRenderFns } from "./ssologin.vue?vue&type=template&id=c9757136&scoped=true"
import script from "./ssologin.vue?vue&type=script&lang=js"
export * from "./ssologin.vue?vue&type=script&lang=js"
import style0 from "./ssologin.vue?vue&type=style&index=0&id=c9757136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9757136",
  null
  
)

export default component.exports